module.exports = __webpack_public_path__ + "img/act_11_step9.c8a625f2.png";